import { yupResolver } from "@hookform/resolvers/yup";
import { t } from "@lingui/macro";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";

import { Button, Input } from "@whoosh/design-system/src/components/controls";
import { FormField } from "@whoosh/design-system/src/components/display";
import { Box, VStack } from "@whoosh/design-system/src/components/primitive";

import { NewGuestFormProps } from "../../../../types";

const schema = yup.object().shape({
  fullName: yup
    .string()
    .required()
    .matches(/\S\s\S/),
  email: yup.string().email(),
});

type NewGuestProps = {
  placeholder?: string;
  closeAddNewGuest: (options?: { clearSearch?: boolean }) => void;
  onNewGuestSubmission: (
    values: NewGuestFormProps,
    onFinish: () => void
  ) => void;
};

export const NewGuest = ({
  placeholder,
  closeAddNewGuest,
  onNewGuestSubmission,
}: NewGuestProps) => {
  const {
    handleSubmit,
    control,
    getValues,
    formState: { errors, isValid },
  } = useForm<NewGuestFormProps>({
    resolver: yupResolver(schema),
    mode: "onBlur",
    defaultValues: {
      fullName: placeholder,
    },
  });

  const handlePlayerSubmission = () => {
    const values = getValues();

    onNewGuestSubmission(values, () => {
      closeAddNewGuest({ clearSearch: true });
    });
  };

  return (
    <Box p={6} backgroundColor="surface-primary" height="100%">
      <VStack>
        <FormField
          title={t`Full Name`}
          errorMessage={
            !!errors.fullName?.message
              ? t`Please add a first and last name.`
              : undefined
          }
          showRequired
          control={
            <Controller
              control={control}
              name={"fullName"}
              render={({ field }) => {
                return (
                  <Input
                    name="fullName"
                    type="text"
                    autoCapitalize="none"
                    placeholder={t`Full Name`}
                    onBlur={field.onBlur}
                    onChange={(val) => field.onChange(val)}
                    value={field.value}
                    hasError={!!errors.fullName}
                  />
                );
              }}
            />
          }
        />
      </VStack>
      <VStack my={4}>
        <FormField
          title={t`Email Address`}
          errorMessage={
            !!errors.email?.message ? t`Please use a valid email.` : undefined
          }
          control={
            <Controller
              control={control}
              name={"email"}
              render={({ field }) => {
                return (
                  <Input
                    name="email"
                    type="text"
                    placeholder={t`guest-email@email.com`}
                    autoCapitalize="none"
                    onBlur={field.onBlur}
                    onChange={(val) => field.onChange(val)}
                    value={field.value}
                  />
                );
              }}
            />
          }
        />
      </VStack>
      <VStack gap={4}>
        <Button
          accessibilityLabel={t`Add Guest button`}
          width="100%"
          isDisabled={!isValid}
          onPress={handleSubmit(handlePlayerSubmission)}
          testID="add-new-guest-button"
        >
          {t`Add Guest`}
        </Button>
        <Button
          width="100%"
          accessibilityLabel={t`Cancel add guest button`}
          onPress={() => {
            closeAddNewGuest();
          }}
          variant="secondary"
          testID="cancel-add-new-guest-button"
        >
          {t`Cancel`}
        </Button>
      </VStack>
    </Box>
  );
};
